const isDebug = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'; // https://stackoverflow.com/a/58556477

const config = {
    APP_NAME: 'Ledger by KesselWorks',

    DEBUG: isDebug,

    /**
     * The default time for browser cache
     */
    //DEFAULT_CACHE_TTL: Infinity, //5 * 60 * 1000 // 5 minutes

    //BASE_URL: isDebug ? 'http://localhost:4000' : window.location.protocol + '//' + window.location.host,
    //BASE_URL: isDebug ? 'http://localhost:8080' : window.location.protocol + '//' + window.location.host,
    BASE_URL: window.location.protocol + '//' + window.location.host,
};

export function setDocumentTitle(title) {
    if (title && title.trim()) {
        document.title = config.APP_NAME + ' - ' + title;
    } else {
        document.title = config.APP_NAME;
    }
}

export default config;
